import React from 'react';
import styled from 'styled-components';
import Modal from './Modal';
import { AppColors } from '../styles/colors';

interface LotEndedModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ConfirmButton = styled.button`
  width: 100%;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  background-color: ${AppColors.btnCEmphasis};
  color: ${AppColors.onBtnCEmphasis};
  
  &:hover {
    background-color: #262626;
    color: #FFFFFF;
  }
`;

const LotEndedModal: React.FC<LotEndedModalProps> = ({
  isOpen,
  onClose
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header="LOT가 종료되었습니다"
      body="해당 LOT의 경매가 종료되었습니다."
      footer={
        <ConfirmButton onClick={onClose}>
          확인
        </ConfirmButton>
      }
      width="320px"
    />
  );
};

export default LotEndedModal;
